import { metadataApi as api } from './metadataSlice';
const injectedRtkApi = api.injectEndpoints({
    endpoints: build => ({
        updateDatasetMetadataMetaDatasetPut: build.mutation<
            UpdateDatasetMetadataMetaDatasetPutApiResponse,
            UpdateDatasetMetadataMetaDatasetPutApiArg
        >({
            query: queryArg => ({ url: `/meta/dataset`, method: 'PUT', body: queryArg.updateDatasetModel }),
        }),
        createNewEmptyDatasetMetaDatasetPost: build.mutation<
            CreateNewEmptyDatasetMetaDatasetPostApiResponse,
            CreateNewEmptyDatasetMetaDatasetPostApiArg
        >({
            query: queryArg => ({ url: `/meta/dataset`, method: 'POST', body: queryArg.createDatasetModel }),
        }),
        searchThroughTheDatasetsMetaSearchPost: build.mutation<
            SearchThroughTheDatasetsMetaSearchPostApiResponse,
            SearchThroughTheDatasetsMetaSearchPostApiArg
        >({
            query: queryArg => ({
                url: `/meta/search`,
                method: 'POST',
                body: queryArg.searchKeyWordModel,
                params: {
                    size: queryArg.size,
                    start: queryArg.start,
                    dataset_type: queryArg.datasetType,
                    project: queryArg.project,
                    access: queryArg.access,
                    workflows: queryArg.workflows,
                    group_id: queryArg.groupId,
                    version: queryArg.version,
                    user: queryArg.user,
                },
            }),
        }),
        searchForDatasetsByDatasetIdMetaSearchDatasetIdGet: build.query<
            SearchForDatasetsByDatasetIdMetaSearchDatasetIdGetApiResponse,
            SearchForDatasetsByDatasetIdMetaSearchDatasetIdGetApiArg
        >({
            query: queryArg => ({ url: `/meta/search/${queryArg.datasetId}` }),
        }),
        getDatasetsStatisticsMetaStatisticsGet: build.query<
            GetDatasetsStatisticsMetaStatisticsGetApiResponse,
            GetDatasetsStatisticsMetaStatisticsGetApiArg
        >({
            query: queryArg => ({
                url: `/meta/statistics`,
                params: {
                    interval: queryArg.interval,
                },
            }),
        }),
        listAvailableDatasetTypesMetaInfoDatasettypesGet: build.query<
            ListAvailableDatasetTypesMetaInfoDatasettypesGetApiResponse,
            ListAvailableDatasetTypesMetaInfoDatasettypesGetApiArg
        >({
            query: () => ({ url: `/meta/info/datasettypes` }),
        }),
        getStatisticsForResourceMetaStatisticsResourcePost: build.mutation<
            GetStatisticsForResourceMetaStatisticsResourcePostApiResponse,
            GetStatisticsForResourceMetaStatisticsResourcePostApiArg
        >({
            query: queryArg => ({
                url: `/meta/statistics/resource`,
                method: 'POST',
                body: queryArg.resourceUsageModel,
            }),
        }),
        getStatisticsForAllResourcesInSpecifiedProjectMetaStatisticsProjectresourcesPost: build.mutation<
            GetStatisticsForAllResourcesInSpecifiedProjectMetaStatisticsProjectresourcesPostApiResponse,
            GetStatisticsForAllResourcesInSpecifiedProjectMetaStatisticsProjectresourcesPostApiArg
        >({
            query: queryArg => ({
                url: `/meta/statistics/projectresources`,
                method: 'POST',
                body: queryArg.projectResourcesUsageModel,
            }),
        }),
        getMetricsFromDdiActionsBasedOnProjectAndTimeIntervalMetaMetricsGet: build.query<
            GetMetricsFromDdiActionsBasedOnProjectAndTimeIntervalMetaMetricsGetApiResponse,
            GetMetricsFromDdiActionsBasedOnProjectAndTimeIntervalMetaMetricsGetApiArg
        >({
            query: queryArg => ({
                url: `/meta/metrics`,
                params: {
                    metric_type: queryArg.metricType,
                    start: queryArg.start,
                    size: queryArg.size,
                    start_time: queryArg.startTime,
                    end_time: queryArg.endTime,
                    time_interval: queryArg.timeInterval,
                    project: queryArg.project,
                },
            }),
        }),
        getAvailableMetricTypesBasedOnUserPermissionsMetaMetricsMetrictypesGet: build.query<
            GetAvailableMetricTypesBasedOnUserPermissionsMetaMetricsMetrictypesGetApiResponse,
            GetAvailableMetricTypesBasedOnUserPermissionsMetaMetricsMetrictypesGetApiArg
        >({
            query: queryArg => ({
                url: `/meta/metrics/metrictypes`,
                params: {
                    project: queryArg.project,
                },
            }),
        }),
        versionOfTheApiMetaInfoGet: build.query<
            VersionOfTheApiMetaInfoGetApiResponse,
            VersionOfTheApiMetaInfoGetApiArg
        >({
            query: () => ({ url: `/meta/info` }),
        }),
        healthOfTheApiMetaHealthApiGet: build.query<
            HealthOfTheApiMetaHealthApiGetApiResponse,
            HealthOfTheApiMetaHealthApiGetApiArg
        >({
            query: () => ({ url: `/meta/health/api` }),
        }),
        healthOfOpenSearchMetaHealthOpensearchGet: build.query<
            HealthOfOpenSearchMetaHealthOpensearchGetApiResponse,
            HealthOfOpenSearchMetaHealthOpensearchGetApiArg
        >({
            query: () => ({ url: `/meta/health/opensearch` }),
        }),
        getSizeOfADatasetByItsIdMetaSizeGet: build.query<
            GetSizeOfADatasetByItsIdMetaSizeGetApiResponse,
            GetSizeOfADatasetByItsIdMetaSizeGetApiArg
        >({
            query: queryArg => ({
                url: `/meta/size`,
                params: {
                    dataset_id: queryArg.datasetId,
                    path: queryArg.path,
                },
            }),
        }),
        getInformationAboutALocationMetaLocationPost: build.mutation<
            GetInformationAboutALocationMetaLocationPostApiResponse,
            GetInformationAboutALocationMetaLocationPostApiArg
        >({
            query: queryArg => ({ url: `/meta/location`, method: 'POST', body: queryArg.locationInfoModel }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as metadata };
export type UpdateDatasetMetadataMetaDatasetPutApiResponse = /** status 200 Successful Response */ DatasetPutreturn;
export type UpdateDatasetMetadataMetaDatasetPutApiArg = {
    updateDatasetModel: UpdateDatasetModel;
};
export type CreateNewEmptyDatasetMetaDatasetPostApiResponse = /** status 200 Successful Response */ DatasetPostReturn;
export type CreateNewEmptyDatasetMetaDatasetPostApiArg = {
    createDatasetModel: CreateDatasetModel;
};
export type SearchThroughTheDatasetsMetaSearchPostApiResponse = /** status 200 Successful Response */ QueryReturn;
export type SearchThroughTheDatasetsMetaSearchPostApiArg = {
    size?: number;
    start?: number;
    datasetType?: string;
    project?: string;
    access?: string;
    workflows?: boolean;
    groupId?: string;
    version?: string;
    user?: string;
    searchKeyWordModel: SearchKeyWordModel;
};
export type SearchForDatasetsByDatasetIdMetaSearchDatasetIdGetApiResponse =
    /** status 200 Successful Response */ QuerySubReturn;
export type SearchForDatasetsByDatasetIdMetaSearchDatasetIdGetApiArg = {
    datasetId: string;
};
export type GetDatasetsStatisticsMetaStatisticsGetApiResponse = /** status 200 Successful Response */ StatisticsReturn;
export type GetDatasetsStatisticsMetaStatisticsGetApiArg = {
    /** One of the following: day, week, month, year */
    interval?: string;
};
export type ListAvailableDatasetTypesMetaInfoDatasettypesGetApiResponse =
    /** status 200 Successful Response */ DatasetTypesReturn;
export type ListAvailableDatasetTypesMetaInfoDatasettypesGetApiArg = void;
export type GetStatisticsForResourceMetaStatisticsResourcePostApiResponse =
    /** status 200 Successful Response */ LocationStatistic[];
export type GetStatisticsForResourceMetaStatisticsResourcePostApiArg = {
    resourceUsageModel: ResourceUsageModel;
};
export type GetStatisticsForAllResourcesInSpecifiedProjectMetaStatisticsProjectresourcesPostApiResponse =
    /** status 200 Successful Response */ ProjectResourcesStatistic[];
export type GetStatisticsForAllResourcesInSpecifiedProjectMetaStatisticsProjectresourcesPostApiArg = {
    projectResourcesUsageModel: ProjectResourcesUsageModel;
};
export type GetMetricsFromDdiActionsBasedOnProjectAndTimeIntervalMetaMetricsGetApiResponse =
    /** status 200 Successful Response */ any;
export type GetMetricsFromDdiActionsBasedOnProjectAndTimeIntervalMetaMetricsGetApiArg = {
    /** Example: actions-count */
    metricType: string;
    /** Example: 20 */
    start?: number;
    /** Example: 10 */
    size?: number;
    /** Example: 2025-01-01 00:00:00 */
    startTime?: string;
    /** Example: 2025-01-31 23:59:59 */
    endTime?: string;
    /** Example: 1h or 1d or 2w or 4M or 1q or 1y  (h - hour, d - day, w - week, M - month, q - quartal, y - year) */
    timeInterval?: string;
    /** Example: my_favorite_project */
    project: string;
};
export type GetAvailableMetricTypesBasedOnUserPermissionsMetaMetricsMetrictypesGetApiResponse =
    /** status 200 Successful Response */ any;
export type GetAvailableMetricTypesBasedOnUserPermissionsMetaMetricsMetrictypesGetApiArg = {
    /** Example: my_favorite_project */
    project: string;
};
export type VersionOfTheApiMetaInfoGetApiResponse = /** status 200 Successful Response */ any;
export type VersionOfTheApiMetaInfoGetApiArg = void;
export type HealthOfTheApiMetaHealthApiGetApiResponse = /** status 200 Successful Response */ any;
export type HealthOfTheApiMetaHealthApiGetApiArg = void;
export type HealthOfOpenSearchMetaHealthOpensearchGetApiResponse = /** status 200 Successful Response */ any;
export type HealthOfOpenSearchMetaHealthOpensearchGetApiArg = void;
export type GetSizeOfADatasetByItsIdMetaSizeGetApiResponse = /** status 200 Successful Response */ any;
export type GetSizeOfADatasetByItsIdMetaSizeGetApiArg = {
    datasetId: string;
    path?: string;
};
export type GetInformationAboutALocationMetaLocationPostApiResponse = /** status 200 Successful Response */ any;
export type GetInformationAboutALocationMetaLocationPostApiArg = {
    locationInfoModel: LocationInfoModel;
};
export type DatasetPutreturn = {
    message?: string;
};
export type ValidationError = {
    loc: (string | number)[];
    msg: string;
    type: string;
    input?: any;
    ctx?: object;
};
export type HttpValidationError = {
    detail?: ValidationError[];
};
export type ResourceTypeGeneral =
    | 'Audiovisual'
    | 'Book'
    | 'BookChapter'
    | 'Collection'
    | 'ComputationalNotebook'
    | 'ConferencePaper'
    | 'ConferenceProceeding'
    | 'DataPaper'
    | 'Dataset'
    | 'Dissertation'
    | 'Event'
    | 'Image'
    | 'InteractiveResource'
    | 'Instrument'
    | 'Journal'
    | 'JournalArticle'
    | 'Model'
    | 'OutputManagementPlan'
    | 'PeerReview'
    | 'PhysicalObject'
    | 'Preprint'
    | 'Report'
    | 'Service'
    | 'Software'
    | 'Sound'
    | 'Standard'
    | 'StudyRegistration'
    | 'Text'
    | 'Workflow'
    | 'Other';
export type Types = {
    resourceType: string;
    resourceTypeGeneral: ResourceTypeGeneral;
};
export type Identifier = {
    identifier: string;
    identifierType: string;
};
export type NameType = 'Organizational' | 'Personal';
export type NameIdentifier = {
    nameIdentifier: string;
    nameIdentifierScheme: string;
    schemeUri?: string | null;
};
export type Affiliation = {
    name: string;
    affiliationIdentifier?: string | null;
    affiliationIdentifierScheme?: string | null;
    schemeUri?: string | null;
};
export type Creator = {
    name: string;
    nameType?: NameType | null;
    givenName?: string | null;
    familyName?: string | null;
    nameIdentifiers?: NameIdentifier[] | null;
    affiliation?: Affiliation[] | null;
    lang?: string | null;
};
export type TitleType = 'AlternativeTitle' | 'Subtitle' | 'TranslatedTitle' | 'Other';
export type Title = {
    title: string;
    titleType?: TitleType | null;
    lang?: string | null;
};
export type Publisher = {
    name: string;
    publisherIdentifier?: string | null;
    publisherIdentifierScheme?: string | null;
    schemeUri?: string | null;
    lang?: string | null;
};
export type Subject = {
    subject: string;
    subjectScheme?: string | null;
    schemeUri?: string | null;
    valueUri?: string | null;
    lang?: string | null;
};
export type ContributorType =
    | 'ContactPerson'
    | 'DataCollector'
    | 'DataCurator'
    | 'DataManager'
    | 'Distributor'
    | 'Editor'
    | 'HostingInstitution'
    | 'Producer'
    | 'ProjectLeader'
    | 'ProjectManager'
    | 'ProjectMember'
    | 'RegistrationAgency'
    | 'RegistrationAuthority'
    | 'RelatedPerson'
    | 'Researcher'
    | 'ResearchGroup'
    | 'RightsHolder'
    | 'Sponsor'
    | 'Supervisor'
    | 'WorkPackageLeader'
    | 'Other';
export type Contributor = {
    contributorType: ContributorType;
    name: string;
    nameType?: NameType | null;
    givenName?: string | null;
    familyName?: string | null;
    nameIdentifiers?: NameIdentifier[] | null;
    affiliation?: Affiliation[] | null;
    lang?: string | null;
};
export type DateType =
    | 'Accepted'
    | 'Available'
    | 'Copyrighted'
    | 'Collected'
    | 'Created'
    | 'Issued'
    | 'Submitted'
    | 'Updated'
    | 'Valid'
    | 'Withdrawn'
    | 'Other';
export type DateModel = {
    date: string;
    dateType: DateType;
    dateInformation?: string | null;
};
export type AlternateIdentifier = {
    alternateIdentifier: string;
    alternateIdentifierType: string;
};
export type RelatedIdentifierType =
    | 'ARK'
    | 'arXiv'
    | 'bibcode'
    | 'DOI'
    | 'EAN13'
    | 'EISSN'
    | 'Handle'
    | 'IGSN'
    | 'ISBN'
    | 'ISSN'
    | 'ISTC'
    | 'LISSN'
    | 'LSID'
    | 'PMID'
    | 'PURL'
    | 'UPC'
    | 'URL'
    | 'URN'
    | 'w3id';
export type RelationType =
    | 'IsCitedBy'
    | 'Cites'
    | 'IsSupplementTo'
    | 'IsSupplementedBy'
    | 'IsContinuedBy'
    | 'Continues'
    | 'IsDescribedBy'
    | 'Describes'
    | 'HasMetadata'
    | 'IsMetadataFor'
    | 'HasVersion'
    | 'IsVersionOf'
    | 'IsNewVersionOf'
    | 'IsPreviousVersionOf'
    | 'IsPartOf'
    | 'HasPart'
    | 'IsPublishedIn'
    | 'IsReferencedBy'
    | 'References'
    | 'IsDocumentedBy'
    | 'Documents'
    | 'IsCompiledBy'
    | 'Compiles'
    | 'IsVariantFormOf'
    | 'IsOriginalFormOf'
    | 'IsIdenticalTo'
    | 'IsReviewedBy'
    | 'Reviews'
    | 'IsDerivedFrom'
    | 'IsSourceOf'
    | 'IsRequiredBy'
    | 'Requires'
    | 'IsObsoletedBy'
    | 'Obsoletes'
    | 'IsCollectedBy'
    | 'Collects';
export type RelatedIdentifier = {
    relatedIdentifier: string;
    relatedIdentifierType: RelatedIdentifierType;
    relationType: RelationType;
    relatedMetadataScheme?: string | null;
    schemeUri?: string | null;
    schemeType?: string | null;
    resourceTypeGeneral?: ResourceTypeGeneral | null;
};
export type RightsListItem = {
    rights?: string | null;
    rightsUri?: string | null;
    rightsIdentifier?: string | null;
    rightsIdentifierScheme?: string | null;
    schemeUri?: string | null;
    lang?: string | null;
};
export type DescriptionType =
    | 'Abstract'
    | 'Methods'
    | 'SeriesInformation'
    | 'TableOfContents'
    | 'TechnicalInfo'
    | 'Other';
export type Description = {
    description: string;
    descriptionType: DescriptionType;
    lang?: string | null;
};
export type GeoLocationPoint = {
    pointLongitude: number;
    pointLatitude: number;
};
export type GeoLocationBox = {
    westBoundLongitude: number;
    eastBoundLongitude: number;
    southBoundLatitude: number;
    northBoundLatitude: number;
};
export type GeoLocationPolygon = {
    polygonPoints: GeoLocationPoint[];
    inPolygonPoint?: GeoLocationPoint | null;
};
export type GeoLocation = {
    geoLocationPlace?: string | null;
    geoLocationPoint?: GeoLocationPoint | null;
    geoLocationBox?: GeoLocationBox | null;
    geoLocationPolygons?: GeoLocationPolygon[] | null;
};
export type FunderIdentifierType = 'ISNI' | 'GRID' | 'Crossref Funder ID' | 'ROR' | 'Other';
export type FundingReference = {
    funderName: string;
    funderIdentifier?: string | null;
    funderIdentifierType?: FunderIdentifierType | null;
    awardNumber?: string | null;
    awardUri?: string | null;
    awardTitle?: string | null;
};
export type Container = {
    type?: string | null;
    title?: string | null;
    firstPage?: string | null;
};
export type RelatedItemIdentifier = {
    relatedItemIdentifier?: string | null;
    relatedItemIdentifierType?: RelatedIdentifierType | null;
};
export type Creator1 = {
    name: string;
    nameType?: NameType | null;
    givenName?: string | null;
    familyName?: string | null;
};
export type NumberType = 'Article' | 'Chapter' | 'Report' | 'Other';
export type Contributor1 = {
    contributorType: ContributorType;
    name: string;
    nameType?: NameType | null;
    givenName?: string | null;
    familyName?: string | null;
};
export type RelatedItem = {
    relatedItemType: ResourceTypeGeneral;
    relationType: RelationType;
    relatedItemIdentifier?: RelatedItemIdentifier | null;
    creators?: Creator1[] | null;
    titles: Title[];
    publicationYear?: number | null;
    volume?: string | null;
    issue?: string | null;
    number?: string | null;
    numberType?: NumberType | null;
    firstPage?: string | null;
    lastPage?: string | null;
    publisher?: string | null;
    edition?: string | null;
    contributors?: Contributor1[] | null;
};
export type Datacite = {
    types?: Types | null;
    identifiers?: Identifier[];
    creators?: Creator[];
    titles?: Title[];
    publisher: Publisher;
    publicationYear: number;
    subjects?: Subject[] | null;
    contributors?: Contributor[] | null;
    dates?: DateModel[] | null;
    language?: string | null;
    alternateIdentifiers?: AlternateIdentifier[] | null;
    relatedIdentifiers?: RelatedIdentifier[] | null;
    sizes?: string[] | null;
    formats?: string[] | null;
    version?: string | null;
    rightsList?: RightsListItem[] | null;
    descriptions?: Description[] | null;
    geoLocations?: GeoLocation[] | null;
    fundingReferences?: FundingReference[] | null;
    container?: Container | null;
    relatedItems?: RelatedItem[] | null;
    schemaVersion?: 'http://datacite.org/schema/kernel-4' | null;
};
export type UpdateDatasetModel = {
    title?: string | null;
    dataset_type?: string | null;
    workflow_id?: string | null;
    workflow_ex_id?: string | null;
    version?: string | null;
    group_id?: string | null;
    provenance?: any[] | null;
    additionalMetadata?: {
        [key: string]: any;
    } | null;
    container_icon?: string | null;
    dataset_id: string;
    datacite?: Datacite | null;
};
export type DatasetPostReturn = {
    dataset_id: string;
};
export type CreateDatasetModel = {
    title?: string | null;
    dataset_type?: string | null;
    workflow_id?: string | null;
    workflow_ex_id?: string | null;
    version?: string | null;
    group_id?: string | null;
    provenance?: any[] | null;
    additionalMetadata?: {
        [key: string]: any;
    } | null;
    container_icon?: string | null;
    target_system: string;
    target_resource: string;
    access: string;
    project: string;
    datacite?: Datacite | null;
};
export type QueryLexisPart = {
    title?: string | null;
    dataset_type?: string | null;
    workflow_id?: string | null;
    workflow_ex_id?: string | null;
    version?: string | null;
    group_id?: string | null;
    provenance?: any[] | null;
    additionalMetadata?: {
        [key: string]: any;
    } | null;
    container_icon?: string | null;
    dataset_id: string;
    absolute_path: string;
    last_modified_date: string;
    creation_date: string;
    zone: string;
    resource_name: string;
    resource_hash: string;
    location_name: string;
    access: string;
    project_shortname: string;
    user: string;
};
export type GeoLocation2 = {
    geoLocationPlace?: string | null;
    geoLocationPoint?: GeoLocationPoint | null;
    geoLocationBox?: GeoLocationBox | null;
    geoLocationPolygons?: GeoLocationPolygon[] | null;
};
export type RelatedItem2 = {
    relatedItemType: ResourceTypeGeneral;
    relationType: RelationType;
    relatedItemIdentifier?: RelatedItemIdentifier | null;
    creators?: Creator1[] | null;
    titles: Title[];
    publicationYear?: number | null;
    volume?: string | null;
    issue?: string | null;
    number?: string | null;
    numberType?: NumberType | null;
    firstPage?: string | null;
    lastPage?: string | null;
    publisher?: string | null;
    edition?: string | null;
    contributors?: Contributor1[] | null;
};
export type Datacite2 = {
    types?: Types | null;
    identifiers?: Identifier[];
    creators?: Creator[];
    titles?: Title[];
    publisher: Publisher;
    publicationYear: number;
    subjects?: Subject[] | null;
    contributors?: Contributor[] | null;
    dates?: DateModel[] | null;
    language?: string | null;
    alternateIdentifiers?: AlternateIdentifier[] | null;
    relatedIdentifiers?: RelatedIdentifier[] | null;
    sizes?: string[] | null;
    formats?: string[] | null;
    version?: string | null;
    rightsList?: RightsListItem[] | null;
    descriptions?: Description[] | null;
    geoLocations?: GeoLocation2[] | null;
    fundingReferences?: FundingReference[] | null;
    container?: Container | null;
    relatedItems?: RelatedItem2[] | null;
    schemaVersion?: 'http://datacite.org/schema/kernel-4' | null;
};
export type QuerySubReturn = {
    lexis: QueryLexisPart;
    datacite?: Datacite2 | null;
};
export type QueryReturn = {
    total: number;
    datasets: QuerySubReturn[];
};
export type SearchKeyWordModel = {
    fields?: {
        [key: string]: any;
    } | null;
};
export type StatisticsReturn = {
    buckets: {
        [key: string]: any;
    }[];
};
export type DatasetTypesReturn = {
    dataset_types: string[];
};
export type LocationStatistic = {
    location_name: string;
    usage: number;
    allocation: number;
    available: number;
    percentage: number;
};
export type ResourceUsageModel = {
    resource_name: string;
};
export type ProjectResourcesStatistic = {
    resource_name: string;
    locations: LocationStatistic[];
};
export type ProjectResourcesUsageModel = {
    project: string;
};
export type LocationInfoModel = {
    target_system: string;
};
export const {
    useUpdateDatasetMetadataMetaDatasetPutMutation,
    useCreateNewEmptyDatasetMetaDatasetPostMutation,
    useSearchThroughTheDatasetsMetaSearchPostMutation,
    useSearchForDatasetsByDatasetIdMetaSearchDatasetIdGetQuery,
    useGetDatasetsStatisticsMetaStatisticsGetQuery,
    useListAvailableDatasetTypesMetaInfoDatasettypesGetQuery,
    useGetStatisticsForResourceMetaStatisticsResourcePostMutation,
    useGetStatisticsForAllResourcesInSpecifiedProjectMetaStatisticsProjectresourcesPostMutation,
    useGetMetricsFromDdiActionsBasedOnProjectAndTimeIntervalMetaMetricsGetQuery,
    useGetAvailableMetricTypesBasedOnUserPermissionsMetaMetricsMetrictypesGetQuery,
    useVersionOfTheApiMetaInfoGetQuery,
    useHealthOfTheApiMetaHealthApiGetQuery,
    useHealthOfOpenSearchMetaHealthOpensearchGetQuery,
    useGetSizeOfADatasetByItsIdMetaSizeGetQuery,
    useGetInformationAboutALocationMetaLocationPostMutation,
} = injectedRtkApi;
